import { Fragment, ReactElement, useEffect } from 'react';
import { IControlledStore, useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IToastItem } from '../../../stores/toasts.store';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import styles from './toast.module.scss';
import { DispatchLogsTypes } from '../../../hooks/use-logs';
import { generateDataAttrs, DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { sendGtagEvent } from '@monorepo/tools/src/lib/tools/tracking';
import { TrackingActions } from '@monorepo/tools/src/lib/consts/tracking/actions';
import { EVENTS } from '@monorepo/tools/src/lib/consts/tracking/events';

// TODO - should be in base?
export const Toast = (props: IToastItem) => {
	const { children, onClose = null, type = DispatchLogsTypes.Success, fullHeight, hideClose, header, msg = '', id = 0 } = props;
	const { toastsStore } = useStores<IControlledStore>();

	const closeToast = () => {
		toastsStore.removeToast(id);
		if (onClose) {
			onClose();
		}
	};

	useEffect(() => {
		if (props.disableClose) return;

		const timer = setTimeout(() => {
			closeToast();
		}, 10000);

		return () => {
			clearTimeout(timer);
		};
	}, [id, props.disableClose]);

	const iconType: { [key: string]: ReactElement } = {
		success: (
			<Icon isMFP={true} color={'#0e7b02'}>
				check
			</Icon>
		),
		info: (
			<Icon isMFP={true} color={'#003378'}>
				info-circle
			</Icon>
		),
		error: (
			<Icon isMFP={true} color={'#cb0000'}>
				alert-circle
			</Icon>
		),
	};

	const msgsType: { [key: string]: string } = {
		success: 'Success!',
		info: 'Info',
		error: 'Something went wrong',
	};

	return (
		<div className={`${styles.content} ${fullHeight ? styles.fullHeight : ''} ${type === DispatchLogsTypes.Error ? styles.error : ''} ${styles}`} {...generateDataAttrs([new DataAttribute('id', 'toast_modal')])}>
			<div className={styles.type}>{iconType[type]}</div>
			<div className={styles.msg}>
				{msg ? (
					<Fragment>
						<div>{header || msgsType[type]}</div>
						<div dangerouslySetInnerHTML={{ __html: msg }} />
					</Fragment>
				) : (
					children
				)}
			</div>
			{!hideClose && (
				<button
					className={styles.close}
					onClick={() => {
						sendGtagEvent({
							action: TrackingActions.Click,
							category: EVENTS.CLICK.TOAST.CLOSE,
							value: msgsType[type],
						});
						closeToast();
					}}>
					<Icon isMFP={true}>x-close</Icon>
				</button>
			)}
		</div>
	);
};
